import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProcessoService } from '@app/services/processo.service';
// import { FuncionarioService } from '@app/services/funcionario.service';
import { Instancia, ProcessoResumo } from '@app/models/processo.model';

@Component({
  selector: 'app-dados-do-processo',
  templateUrl: './dados-do-processo.component.html',
  styleUrls: ['./dados-do-processo.component.scss']
})
export class DadosDoProcessoComponent implements OnInit {

  processoResumo: ProcessoResumo;
  listaGrupoInstancia: Map<string, Instancia[]> = new Map();
  private _idProcesso: number;

  get idProcesso(): number {
    return this._idProcesso;
  }

  @Input()
  set idProcesso(id: number) {
    this._idProcesso = id;
    this.obterDados(this._idProcesso);
  }

  @Input()
  titulo: string;

  @Output() enviaProcessoResumo = new EventEmitter();

  constructor(
    private route: ActivatedRoute,
    private processoService: ProcessoService,
  ) {
    this.processoResumo = new ProcessoResumo();
  }

  ngOnInit() {
    if (this.idProcesso == null) {
      this.route.parent.params.subscribe(
        (params: any) => {
          let id = params['id'];
          if (id.includes('-e')) {
            id = id.split('-e')[0];
          }
          this.obterDados(id);
        });
    }
  }

  obterDados(processoId: number) {
    this.listaGrupoInstancia = new Map();
    this.processoService.obterDados(processoId)
      .subscribe(data => {
        this.processoResumo = data;
        this.processoResumo.InstanciasProcesso.forEach(instancia => {
          if(!this.listaGrupoInstancia.has(instancia.DescricaoInstancia)){
            this.listaGrupoInstancia.set(instancia.DescricaoInstancia, [instancia]);
          } else {
            let temp = this.listaGrupoInstancia.get(instancia.DescricaoInstancia)
            this.listaGrupoInstancia.set(instancia.DescricaoInstancia, [...temp,instancia]);
          }
        this.enviaProcessoResumo.emit(data);
        })
      });
  }
}
